<script>
  import { getId, addElement, getLayoutComponent } from './builder.js'
  import { onDestroy } from 'svelte'

  export let config = {}

  export let name = null
  export let value = false
  export let id = getId()
  export let disabled = null
  export let indeterminate = false

  export let format = null
  export let validate = null
  export let label = name || ''
  export let info = null
  export let required = null
  export let loading = null
  export let readonly = null

  const elementName = 'Checkbox'
  const element = addElement(v => {
    value = !!v
  })
  $: element.init({ value, format, validate, label, info, disabled, required, loading })

  export const validateValue = element.validateValue

  onDestroy(element.selfDestroy)
</script>

<svelte:component this={getLayoutComponent(elementName)} let:inputClass {config} {elementName} {id}>
  <input
    type="checkbox"
    bind:checked={$element.value}
    bind:indeterminate
    {id}
    {name}
    disabled={disabled || readonly}
    on:focus
    on:blur
    on:change
    on:focus={element.onEvent}
    on:blur={element.onEvent}
    on:change={element.onEvent}
    class={inputClass}
    aria-required={!!required}
    aria-invalid={!!$element.error}
    aria-describedby={$element.error ? `${id}-error` : info ? `${id}-description` : null}
  />
</svelte:component>
